/**
 * @typedef {"local-me" | "local-partner"} PersonId
 */

/**
 * @typedef {"EQUAL_50_50" | "FULL_REIMBURSEMENT"} SplitMode
 */

/**
 * @typedef {"WEEKLY" | "MONTHLY"} RecurringFrequency
 */

/**
 * @typedef {Object} Expense
 * @property {string} id
 * @property {string} date
 * @property {string} description
 * @property {number} amount
 * @property {string} category
 * @property {PersonId} paid_by
 * @property {number | null} split_amount
 * @property {SplitMode} split_mode
 * @property {string | null} note
 * @property {string} created_at
 * @property {string} updated_at
 */

/**
 * @typedef {Object} Settlement
 * @property {string} id
 * @property {number} amount
 * @property {PersonId} settled_by
 * @property {string} settled_at
 * @property {string | null} note
 */

/**
 * @typedef {Object} RecurringRule
 * @property {string} id
 * @property {string} description
 * @property {number} amount
 * @property {string} category
 * @property {PersonId} paid_by
 * @property {SplitMode} split_mode
 * @property {number | null} split_amount
 * @property {string | null} note
 * @property {RecurringFrequency} frequency
 * @property {string} start_date
 * @property {string | null} end_date
 * @property {boolean} active
 * @property {string | null} last_generated_at
 * @property {string} created_at
 * @property {string} updated_at
 */

/**
 * @typedef {Object} Settings
 * @property {string} meName
 * @property {string} partnerName
 * @property {string} currency
 * @property {boolean} hasCompletedSetup
 */

/**
 * @typedef {Object} AppState
 * @property {number} schemaVersion
 * @property {Expense[]} expenses
 * @property {Settlement[]} settlements
 * @property {RecurringRule[]} recurringRules
 * @property {Settings} settings
 */

export const PERSON = {
  ME: "local-me",
  PARTNER: "local-partner",
};

export const SPLIT_MODE = {
  EQUAL_50_50: "EQUAL_50_50",
  FULL_REIMBURSEMENT: "FULL_REIMBURSEMENT",
};

export const RECURRING_FREQUENCY = {
  WEEKLY: "WEEKLY",
  MONTHLY: "MONTHLY",
};

export const DEFAULT_CATEGORIES = [
  "Groceries",
  "Dining",
  "Housing",
  "Utilities",
  "Transport",
  "Entertainment",
  "Travel",
  "Health",
  "Shopping",
  "Other",
];

/**
 * @returns {Settings}
 */
export function createDefaultSettings() {
  return {
    meName: "You",
    partnerName: "Partner",
    currency: "USD",
    hasCompletedSetup: false,
  };
}

/**
 * @returns {AppState}
 */
export function createEmptyState() {
  return {
    schemaVersion: 1,
    expenses: [],
    settlements: [],
    recurringRules: [],
    settings: createDefaultSettings(),
  };
}
